import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { join } from 'lodash';
import {
  CheckboxWrapper,
  // FieldWithUnits,
  FrequencyForm,
  GridItem,
  TextFieldWrapper,
} from './../../common';
import ConcentrationForm from './ConcentrationForm';
import { ACTIVE_NUMERATOR, FREQUENCY, FREQUENCY_UNIT, PRN } from '../constants';

function IVForm({ paths }) {
  return (
    <React.Fragment>
      <GridItem lg={2} xs={12}>
        <Field
          component={TextFieldWrapper}
          id={ACTIVE_NUMERATOR}
          label="Concentration"
          name={join([...paths, ACTIVE_NUMERATOR], '.')}
          paths={[...paths, ACTIVE_NUMERATOR]}
          type="number"
        />
      </GridItem>
      <GridItem lg={3} xs={12}>
        <ConcentrationForm paths={paths} />
      </GridItem>
      <FrequencyForm
        frequencyFieldName={FREQUENCY}
        paths={paths}
        unitsFieldName={FREQUENCY_UNIT}
      />
      <GridItem lg={4} xs={12}>
        <Field
          component={CheckboxWrapper}
          id={PRN}
          label="PRN (As Needed)"
          name={join([...paths, PRN], '.')}
          paths={[...paths, PRN]}
        />
      </GridItem>
    </React.Fragment>
  );
}

IVForm.propTypes = {
  paths: PropTypes.array,
};

IVForm.defaultProps = {
  paths: [],
};

export default IVForm;



// WEBPACK FOOTER //
// ./src/modules/MedicationPage/components/IVForm.js